
export const CodigoNotaria = '1';
export const UrlApi = 'https://sinfony.com.co/api/public/api/';

// Links de redes sociales. Si el proyecto no tiene cuenta propia, se usa el
// home genérico de cada red. Para apuntar a una cuenta real, definir la
// variable de entorno correspondiente (REACT_APP_SOCIAL_*) en el .env.
export const SocialLinks = {
  facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://www.facebook.com/',
  instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com/',
  x: process.env.REACT_APP_SOCIAL_X || 'https://www.x.com/',
};

// Genesys Cloud Messenger.
// El UUID del deployment es siempre `deploymentId` (aunque el .env use otro nombre).
// Sin ambas llaves, el botón de chat no se monta; WhatsApp sigue visible.
export const GenesysEnvironment = 'prod';
export const GenesysDeploymentId = '31daa4b0-b432-453b-acd2-ce2206f962af';
